// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15Zp7","label":"styles_label__2Ag7X"};